import * as React from 'react';
import { NavigationUserModel } from '.';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from 'src/api';

import MESSAGES from './navigation-user.messages';
import { NavigationAdminModel } from './navigation-user.model';

export const navigationUserData = (): NavigationUserModel => ({
  configurationOverview: {
    active: false,
    disabled: true,
    icon: '',
    name: <FormattedMessage {...MESSAGES.configurationName} />,
    title: formatMessage({...MESSAGES.configurationName}),
    to: `/`,
  },
  account: {
    active: false,
    disabled: true,
    icon: '',
    name: <FormattedMessage {...MESSAGES.accountName} />,
    title: formatMessage({...MESSAGES.accountName}),
    to: `/profile/account`,
  },
  addresses: {
    active: false,
    disabled: true,
    icon: '',
    name: <FormattedMessage {...MESSAGES.adressesName} />,
    title: formatMessage({...MESSAGES.adressesName}),
    to: `/profile/projects`,
  }
});

export const navigationAdminData = (): NavigationAdminModel => ({
  all: {
    active: false,
    disabled: true,
    icon: '',
    name: 'Manage all users',
    title: 'Manage all users',
    to: `/`,
  },
  postcodes: {
    active: false,
    disabled: true,
    icon: '',
    name: 'Postcode areas',
    title: 'Postcode areas',
    to: `/postcodes`,
  },
  // pricesAccessories: {
  //   active: false,
  //   disabled: true,
  //   icon: '',
  //   name: 'Prices accessories',
  //   title: 'Prices accessories',
  //   to: `/pricings-accessories`,
  // },
  pricings: {
    active: false,
    disabled: true,
    icon: '',
    name: 'Time periods and markets',
    title: 'Time periods and markets',
    to: `/pricings`,
  },
});